import { render, staticRenderFns } from "./BDXStatusModal.vue?vue&type=template&id=7003babd"
import script from "./BDXStatusModal.vue?vue&type=script&lang=js"
export * from "./BDXStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports